import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Select, { components } from 'react-select'
import user3 from '../assets/images/user4.png'
import { useGetChildQuery } from '../redux/api/childApi'
import { setSelectedUser } from '../redux/slice/userSlice'

const UserSelector = () => {
  const dispatch = useDispatch()
  const { selectedUser } = useSelector((state) => state.user)
  const { userToken } = useSelector((state) => state.auth)
  const {
    data: children,
    isLoading,
    isError,
    error,
    isSuccess,
  } = useGetChildQuery({ userToken })

  useEffect(() => {
    const user = selectedUser || (children && children[0])
    dispatch(setSelectedUser(user))
  }, [dispatch, isSuccess, children])

  if (isLoading) return <div>Loading...</div>
  if (isError) return <div>{error.message}</div>

  // Sort and group options by first letter
  const groupedOptions = () => {
    if (!children) return []

    // First, ensure each child has a label property
    const validChildren = children.map((child) => ({
      ...child,
      label: child.label || child.name || 'Unnamed', // Fallback if label is missing
    }))

    const sorted = [...validChildren].sort((a, b) =>
      a.label.localeCompare(b.label)
    )
    const groups = {}

    sorted.forEach((child) => {
      const firstLetter = child.label.charAt(0).toUpperCase()
      if (!groups[firstLetter]) {
        groups[firstLetter] = []
      }
      groups[firstLetter].push(child)
    })

    // Convert groups into the format expected by react-select
    return Object.keys(groups)
      .sort()
      .reduce((acc, letter) => {
        acc.push({
          label: letter,
          options: groups[letter],
        })
        return acc
      }, [])
  }

  const options = groupedOptions()

  const handleChange = (user) => {
    dispatch(setSelectedUser(user))
  }

  const customOption = ({ data, ...props }) => (
    <components.Option {...props}>
      <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
        <img
          src={data?.image === 'image' ? user3 : data?.image}
          alt='user4'
          width={24}
          height={24}
          className='rounded-circle'
        />
        <span>{data.label}</span>
      </div>
    </components.Option>
  )

  const customSingleValue = ({ data, ...props }) => (
    <components.SingleValue {...props}>
      <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
        <img
          src={data?.image === 'image' ? user3 : data?.image}
          alt='user4'
          width={24}
          height={24}
          className='rounded-circle'
        />
        <span>{data.label}</span>
      </div>
    </components.SingleValue>
  )

  const GroupHeader = ({ children, ...props }) => (
    <div
      style={{
        padding: '8px 12px',
        backgroundColor: '#f8f9fa',
        color: '#6c757d',
        fontWeight: 'bold',
        borderBottom: '1px solid #dee2e6',
      }}
    >
      {children}
    </div>
  )

  return (
    <div className='d-flex '>
      <div style={{ minWidth: '150px' }}>
        <Select
          options={options}
          defaultValue={selectedUser}
          onChange={handleChange}
          components={{
            Option: customOption,
            SingleValue: customSingleValue,
            Group: ({ children, data }) => (
              <div>
                <GroupHeader>{data.label}</GroupHeader>
                {children}
              </div>
            ),
          }}
          formatGroupLabel={(data) => data.label}
        />
      </div>
    </div>
  )
}

export default UserSelector
